export default __webpack_public_path__ + "static/media/Icon=Products.918084c8.svg";